import React from 'react';
import GasStationCStorePOS from './GasStationCStorePOS';

const GasStationPOS = () => {
  return <GasStationCStorePOS />;
};

export default GasStationPOS;
